<template>
  <div class="list-item flex flex-column">
    <component :is="linkComponent" :to="{ name: 'claim_card', params: { id: item.claimId } }" class="link entity-primary">
      <div class="flex flex-row justify-between f6">
        <span class="db">{{ formatDate() }}</span>
        <span class="db entity-secondary">{{ timeAgo(item.date) }}</span>
      </div>
      <div class="mt3 flex flex-column f6 ttl">
        <span class="b">{{ item.state }}</span>
      </div>
      <div class="mt3 flex flex-column f6 ttl">
        <span v-if="showClaim" class="ttu tracked f7 entity-secondary">
          <span v-if="hightPriority" class="pr1 red f6">
            <font-awesome-icon icon="fire-alt" />
          </span>
          заявка
          <span class="pl1 ttu tracked">№ {{ item.claimId }}</span>
        </span>
      </div>
      <div v-if="showClaim" class="mb3 f6 lh-copy">
        <span class="text-line-1 underline">
          {{ item.claimName }}
        </span>
      </div>
      <div class="entity-secondary lh-copy f6">
        <div v-if="item.userName">
          <span class="f7 pr2"><font-awesome-icon :icon="['fa', 'user']" /></span>
          {{ item.userName }}
        </div>
        <div v-if="item.departmentName">
          <span class="f7 pr2"><font-awesome-icon :icon="['far', 'building']" /></span>
          {{ item.departmentName }}
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { momentFromString } from '@/utils/datetime.js'

export default {
  props: ['item', 'showClaim'],
  computed: {
    ...mapGetters('companyInfo', ['managers', 'departments']),
    ...mapGetters('claim', ['claims', 'status']),
    hightPriority () {
      return this.item.priority_id === 1
    },
    linkComponent () {
      return this.showClaim ? 'router-link' : 'div'
    }
  },
  methods: {
    statusDateTime (datetime) {
      return momentFromString(datetime)?.format('DD.MM.YYYY hh:mm')
    },
    timeAgo (datetime) {
      return momentFromString(datetime)?.fromNow()
    },
    day () {
      return momentFromString(this.item.date)?.date()
    },
    month () {
      return momentFromString(this.item.date)?.format('MMM')
    },
    year () {
      return momentFromString(this.item.date)?.year()
    },
    formatDate () {
      return momentFromString(this.item.date)?.format('D MMM YYYY ddd HH:MM')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
